import { useEffect, useState } from 'react';
import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';

interface UseGetInitialPromptParams {
    leafCategory?: number;
    searchQuery?: string;
}

interface GetInitialPromptResponse {
    initialPrompt: string;
    profession: string;
}

const buildUrlWithSearchParams = (baseUrl: string, params: Record<string, any>) => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            searchParams.append(key, String(value));
        }
    });

    const queryString = searchParams.toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

export const useGetInitialPrompt = ({ leafCategory, searchQuery }: UseGetInitialPromptParams) => {
    const [data, setData] = useState<GetInitialPromptResponse | null>(null);

    useEffect(() => {
        if (!leafCategory && !searchQuery) return;

        let isMounted = true;
        const maxRetries = 3;
        let attempt = 0;

        const fetchData = async () => {
            while (attempt < maxRetries) {
                try {
                    const url = buildUrlWithSearchParams(pathfinder('get_dm_initial_prompt'), {
                        leaf_category_id: leafCategory,
                        query_slug: searchQuery,
                    });

                    const response = await axios.get(url);

                    if (isMounted) {
                        setData(response.data);
                    }

                    return;
                } catch (err: any) {
                    if (err?.response?.status === 404) {
                        return;
                    }

                    attempt++;
                }
            }
        };

        fetchData();

        return () => {
            isMounted = false;
        };
    }, [leafCategory, searchQuery]);

    return { data };
};
